module.exports = __webpack_public_path__ + "static/assets/1e9845b965f84b5719b7232a81fefc84.ttf";